import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '@shared/share.module';
import { BadRequestComponent } from './bad-request/bad-request.component';
import { ErrorComponentComponent } from './error-component/error-component.component';
import { ErrorsRoutingModule } from './errors.routing';
import { ForbiddenComponent } from './forbidden/forbidden.component';
import { InternalServerErrorComponent } from './internal-server-error/internal-server-error.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { TimeoutComponent } from './timeout/timeout.component';

@NgModule({
  declarations: [
    BadRequestComponent,
    ForbiddenComponent,
    InternalServerErrorComponent,
    TimeoutComponent,
    NotFoundComponent,
    ErrorComponentComponent,
  ],
  imports: [CommonModule, ErrorsRoutingModule, SharedModule],
})
export class ErrorsModule {}
